<div class="chat-panel">
  <div
    class="chat-header"
    (click)="closeRequested.emit()"
  >
    <div class="header-title">
      <mat-icon>smart_toy</mat-icon>
      <span>{{ 'chatbot.title' | translate }}</span>
    </div>
    <div class="header-actions">
      @if (isDailyReportActive && dailyReportState().result && dailyReportState().isDismissed) {
        <button
          mat-icon-button
          (click)="$event.stopPropagation(); restoreDailyReport()"
          [matTooltip]="'chatbot.daily_report.show' | translate"
          [attr.aria-label]="'chatbot.daily_report.show' | translate"
        >
          <mat-icon>bar_chart</mat-icon>
        </button>
      }
      <button
        mat-icon-button
        (click)="$event.stopPropagation(); openReportProblemDialog()"
        [matTooltip]="'chatbot.report_problem' | translate"
      >
        <mat-icon>report_problem</mat-icon>
      </button>
      <button
        mat-icon-button
        (click)="$event.stopPropagation(); clearChat()"
        [matTooltip]="'chatbot.clear_chat' | translate"
      >
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </div>

  @if (isDailyReportActive && dailyReportState().result && !dailyReportState().isDismissed) {
    <div class="daily-report-wrapper">
      <app-chat-daily-report-card
        [result]="dailyReportState().result!"
        (dismissed)="dismissDailyReport()"
      />
    </div>
  }

  <div
    class="chat-messages"
    #messagesContainer
  >
    @if (state.persistenceError) {
      <div class="warning-message">
        <mat-icon>warning</mat-icon>
        <span>{{ state.persistenceError | translate }}</span>
        <button
          mat-icon-button
          (click)="dismissPersistenceError()"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>
    }

    @if (state.messages.length === 0) {
      <div class="empty-state">
        @if (!isDailyReportActive || !dailyReportState().result || dailyReportState().isDismissed) {
          <mat-icon>chat_bubble_outline</mat-icon>
          <p>{{ 'chatbot.empty_state_title' | translate }}</p>
        }
        <p class="hint">{{ 'chatbot.empty_state_hint' | translate }}</p>
        <div class="suggestions">
          @for (suggestion of suggestions; track suggestion) {
            <button
              class="suggestion-bubble"
              (click)="sendSuggestion(suggestion)"
            >
              {{ suggestion }}
            </button>
          }
        </div>
      </div>
    } @else {
      @for (message of state.messages; track message.id) {
        <app-chat-message [message]="message"></app-chat-message>
      }
    }

    @if (state.error) {
      <div class="error-message">
        <mat-icon>error_outline</mat-icon>
        <span>{{ state.error.message | translate }}</span>
      </div>
    }
  </div>

  @if (shouldShowContextWarning) {
    <div
      class="context-warning-banner"
      [class.is-critical]="state.contextUsage?.isCritical || state.hasReachedContextLimit"
    >
      <!-- Decorative duplicate of the adjacent percentage text; hidden so screen readers announce it once. -->
      <span
        class="context-usage-inline-ring"
        aria-hidden="true"
        [style.--context-progress]="contextProgressStyle"
      ></span>
      <span class="context-usage-value">
        {{ 'chatbot.context_usage_short' | translate: { percentage: remainingContextPercentage } }}
      </span>
      <button
        mat-icon-button
        type="button"
        class="context-info-button"
        [matTooltip]="contextWarningTranslationKey | translate"
        matTooltipPosition="above"
        [attr.aria-label]="contextWarningTranslationKey | translate"
      >
        <mat-icon>info</mat-icon>
      </button>
    </div>
  }

  <div class="chat-input">
    <div
      class="input-wrapper"
      [class.near-limit]="isNearMaxLength"
      [class.at-limit]="isAtMaxLength"
    >
      <textarea
        #inputField
        [(ngModel)]="inputValue"
        (input)="adjustTextareaHeight()"
        (keydown)="onKeydown($event)"
        resize="none"
        [placeholder]="
          state.hasReachedContextLimit
            ? ('chatbot.limit_reached_placeholder' | translate)
            : ('chatbot.input_placeholder' | translate)
        "
        [disabled]="!canSendMessages"
        [maxLength]="maxInputLength"
        class="message-input"
      ></textarea>
      <span
        class="send-button-tooltip-wrapper"
        [matTooltip]="'chatbot.limit_reached_placeholder' | translate"
        [matTooltipDisabled]="!shouldShowClearChatSendTooltip"
        matTooltipPosition="above"
      >
        <button
          mat-icon-button
          (click)="sendMessage()"
          [disabled]="!inputValue.trim() || !canSendMessages"
          [attr.aria-label]="
            state.isLoading ? ('chatbot.sending_message' | translate) : ('chatbot.send_message' | translate)
          "
          class="send-button"
        >
          <mat-icon>send</mat-icon>
        </button>
      </span>
    </div>
    @if (isNearMaxLength) {
      <div
        class="input-warning"
        [class.at-limit]="isAtMaxLength"
      >
        <span>{{ inputValue.length }}/{{ maxInputLength }}</span>
      </div>
    }
  </div>

  <div class="disclaimer">
    {{ 'chatbot.disclaimer' | translate }}
  </div>
</div>
